import React, {
  useMemo,
  useRef,
  useState
} from "react";
import forward from "../../Assets/next-arrow.png";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "../../Components/Navbar/Navbar";
import ContactCTA from "../../Components/ContactCTA/ContactCTA";
import Footer from "../../Components/Footer/Footer";
import projects, {
  projectCategories
} from "../../data/projects";
import useWorkPageAnimations from "./useWorkPageAnimations";
import "./Work.css";


import {
  FaArrowRight

} from "react-icons/fa";

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 60
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};

function Work() {
  const pageRef = useRef(null);
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredProjects = useMemo(() => {
    if (activeCategory === "All") {
      return projects;
    }

    return projects.filter(
      (project) => project.category === activeCategory
    );
  }, [activeCategory]);

  const categoryCounts = useMemo(() => {
    return projectCategories.reduce(
      (counts, category) => {
        counts[category] =
          category === "All"
            ? projects.length
            : projects.filter(
                (project) =>
                  project.category === category
              ).length;

        return counts;
      },
      {}
    );
  }, []);

  useWorkPageAnimations(
    pageRef,
    activeCategory
  );

  return (
    <>
      <Navbar />

      <main
        ref={pageRef}
        className="work-page"
      >

        <section className="work-hero">

          <div className="work-hero-glow"></div>

          <div className="work-container">

            <motion.h1
              className="work-hero-title"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              Our Work
            </motion.h1>

            <motion.p
              className="work-hero-description"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              Explore our work in branding, design, websites, creative content, and digital marketing,
              created to help businesses grow and connect with their audience
            </motion.p>

              <motion.div
                          className="sp-hero-actions"
                          variants={fadeUp}
                          initial="hidden"
                          whileInView="show"
                          viewport={{ once: true }}
                        >
                          <Link to="/contact" className="about-primary-btn">
                            Start Your Project
                            <img
                              src={forward}
                              alt="arrow"
                              className="cta-arrow"
                            />
                          </Link>
                        </motion.div>

          </div>

        </section>

        <section className="work-archive">

          <div className="work-container">

            <motion.div
              className="work-section-heading"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >


              <h2>
                Stories We Have Brought To Life
              </h2>

              <p>
                Explore a selection of projects created across film,
                photography, campaigns and visual production.
              </p>

            </motion.div>

            <div className="work-filter">

              <span className="work-filter-label">
                FILTER PROJECTS
              </span>

              <div className="work-filter-buttons">

                {projectCategories.map(
                  (category) => (

                    <button
                      type="button"
                      key={category}
                      className={`work-filter-button ${
                        activeCategory === category
                          ? "work-filter-button-active"
                          : ""
                      }`}
                      onClick={() =>
                        setActiveCategory(category)
                      }
                    >

                      <span>
                        {category}
                      </span>

                      <span>
                        {String(
                          categoryCounts[category]
                        ).padStart(2, "0")}
                      </span>

                    </button>

                  )
                )}

              </div>

            </div>

            <div className="work-grid">

              {filteredProjects.map(
                (project, index) => (

                  <article
                    className="work-project"
                    key={project.id}
                  >

                    <Link
                      to={`/work/${project.slug}`}
                      className="work-project-link"
                    >

                      <div className="work-project-image">

                        <img
                          src={project.image}
                          alt={project.title}
                          loading="lazy"
                        />

                        <div className="work-project-overlay"></div>

                        <div className="work-project-view">

                          <span className="work-project-view-label">
                            VIEW PROJECT
                          </span>

                          <span className="work-project-view-arrow">
                            <FaArrowRight id="right-arrow"/>
                          </span>

                        </div>

                        <div className="work-project-image-meta">

                          <span>
                            {String(index + 1).padStart(
                              2,
                              "0"
                            )}
                          </span>

                          <span>
                            {project.year}
                          </span>

                        </div>

                      </div>

                      <div className="work-project-information">

                        <span className="work-project-category">
                          {project.category}
                        </span>

                        <h2>
                          {project.title}
                        </h2>

                        <div className="work-project-details">


                        </div>

                      </div>

                    </Link>

                  </article>

                )
              )}

            </div>

          </div>

        </section>

      </main>

      <ContactCTA />

      <Footer />
    </>
  );
}

export default Work;